/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import CustomButton from '../../../../shared/forms/CustomButton';
import AppContext from '../../../../../../context/shared/AppContext';
import Label from '../../../../shared/forms/Label';
import CustomInput from '../../../../shared/forms/CustomInput';

const AddPtpVlanIp = () => {
  const { loadingForm, onChange, formValue, onSubmit } = useContext(AppContext);
  const { ip_address, vlan_ip_ptp, vlan_ip_ptmp, device_name, ssid, device_type } = formValue;
  const submitForm = () => {
    return (
      device_name.length > 0 &&
      ip_address.length > 0 &&
      vlan_ip_ptp.length > 0 &&
      ssid.length > 0 &&
      device_type.length &&
      vlan_ip_ptmp.length > 0 &&
      device_name.length > 0
    );
  };
  return (
    <div id="add-access-point" className="modal fade mt-5" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header shadow">
            <h4 className="modal-title update_asset">PTP VLAN IP</h4>
            <button type="button" className="btn btn-outline-info btn-circle btn-close" data-dismiss="modal">
              x
            </button>
          </div>
          <div className="modal-body detail mb-4 p-0">
            <form
              className="col-md-12 p-0"
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              {/* <div className="d-flex"> */}
              {/*  <div className="form-group col-6"> */}
              {/*    <Label classname="m-0 p-0 copy-font" name="Site Name" /> */}
              {/*    <select */}
              {/*      className="form-control border border-info p-2" */}
              {/*      id="class" */}
              {/*      name="basestation_name" */}
              {/*      style={{ borderRadius: '0' }} */}
              {/*      onChange={onChange} */}
              {/*    > */}
              {/*      <option>--Basestation--</option> */}
              {/*      {data.map((basestation: { name: string }) => { */}
              {/*        return <CustomDropdownOption value={basestation.name} name={basestation.name} />; */}
              {/*      })} */}
              {/*    </select> */}
              {/*  </div> */}
              {/*  <div className="form-group col-6"> */}
              {/*    <Label classname="m-0 p-0 copy-font" name="IP Address" /> */}

              {/*    <CustomInput */}
              {/*      classname="form-control border border-info p-2" */}
              {/*      name="ip_address" */}
              {/*      value={ip_address} */}
              {/*      onChange={onChange} */}
              {/*      readOnly={false} */}
              {/*      placeholder="eg (10.0.2.1)" */}
              {/*      type="text" */}
              {/*      id="customerEmail" */}
              {/*    /> */}
              {/*  </div> */}
              {/* </div> */}

              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="IP Address" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="ip_address"
                    value={ip_address}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="eg (23.4.5.4)"
                    type="text"
                    id="customerEmail"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="SSID" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="ssid"
                    value={ssid}
                    onChange={onChange}
                    readOnly={false}
                    placeholder=""
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Vlan IP PTP" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="vlan_ip_ptp"
                    value={vlan_ip_ptp}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="e.g (23.4.5.4)"
                    type="text"
                    id="customerEmail"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Vlan IP PTMP" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="vlan_ip_ptmp"
                    value={vlan_ip_ptmp}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="e.g (39.39.1)"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>

              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Device Name" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="device_name"
                    value={device_name}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="CG-r8r"
                    type="text"
                    id="customerEmail"
                  />
                </div>

                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Device Type" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="device_type"
                    value={device_type}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="Router"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>

              <div className="text-center mt-3">
                {loadingForm ? (
                  <CustomButton classname="btn btn-green px-3" name="Adding..." disabled={loadingForm} />
                ) : (
                  <CustomButton classname="btn btn-green px-3" name="Add" disabled={!submitForm()} />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPtpVlanIp;
